import React from "react";
import useData from "../lib/useData";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import TicketList from "./TicketList";
import DoughnutChart from "../components/DoughnutChart";
import BarChart from "../components/BarChart";

export default function Dashboard() {
  const { doughnutChartData, barChartData, ...listProps } = useData(true); // Pass true for list view

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {/* Charts */}
      <Grid
        container
        wrap="wrap"
        sx={{
          margin: isDesktop ? "0 -16px" : "0",
          padding: "0",
          width: isDesktop ? "calc(100% + 16px)" : "100%",
        }}
        spacing={4}
      >
        <Grid item lg={4} md={6} sm={12} xs={12} sx={{ flex: 1 }}>
          <DoughnutChart doughnutChartData={doughnutChartData} />
        </Grid>
        <Grid item lg={8} md={6} sm={12} xs={12} sx={{ flex: 1 }}>
          <BarChart barChartData={barChartData} />
        </Grid>
      </Grid>

      {/* Ticket List */}
      <TicketList {...listProps} />
    </Box>
  );
}
